import module from 'nominas/sumario/module.js'
import template from './template.html'
import { isDate } from 'lodash'
import * as moment from 'moment'

const unificarPeriodo = (fechaInicial, fechaFinal) => {
  let inicial = moment(fechaInicial).format('YYYY,MMMM,D').split(',')
  const final = moment(fechaFinal).format('YYYY,MMMM,D').split(',')
  const coincide = {
    periodo: inicial[0] === final[0],
    mes: inicial[1] === final[1],
    dia: inicial[2] === final[2],
  }

  if (coincide.periodo && coincide.mes && coincide.dia) return `${final[2]} de ${final[1]} de ${final[0]}`
  if (coincide.periodo && coincide.mes) return `${inicial[2]} al ${final[2]} de ${final[1]} de ${final[0]}`
  if (coincide.periodo) return `${inicial[2]} de ${inicial[1]} al ${final[2]} de ${final[1]} de ${final[0]}`
  return `${inicial[2]} de ${inicial[1]} de ${inicial[0]} al ${final[2]} de ${final[1]} de ${final[0]}`
}

export class NominasSumarioListaComponent {
  busqueda
  permisos
  data
  filtro = ''
  completado = false
  promise

  constructor ($configCache, NominasSumario) {
    this.NominasSumario = NominasSumario
    this.opciones = $configCache.get('nominas-sumario-lista', {etiquetas: false, expandido: false})
  }

  $onChanges (changes) {
    if (changes.busqueda) {
      const {idProyectos, fechaInicial, fechaFinal, idMoneda} = this.busqueda
      if (!isDate(fechaInicial) || !isDate(fechaFinal) || !Array.isArray(idProyectos) || !Number.isFinite(idMoneda)) return

      this.promise = this.NominasSumario.get(this.busqueda)
        .then((response) => {
          const periodo = (new Date()).getFullYear()
          this.data = response.data.map((nomina) => {
            let formato = nomina.fecha.getFullYear() === periodo ? 'MMMM DD' : 'MMMM DD, YYYY'
            nomina.agrupacion = moment(nomina.fecha).format(formato).toUpperCase()
            nomina.periodo = `Del ${unificarPeriodo(nomina.fecha_inicial, nomina.fecha_final)}`

            return nomina
          })
        })
    }
  }
}

module.component('nominasSumarioLista', {
  controller: NominasSumarioListaComponent,
  template,
  bindings: {
    busqueda: '<',
    permisos: '<',
  },
})



// WEBPACK FOOTER //
// ./src/nominas/sumario/components/lista/component.js